import React, { useEffect } from 'react';

export default function Modal({ abierto, onCerrar, titulo, children, ancho = '540px' }) {
  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onCerrar(); };
    if (abierto) document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [abierto, onCerrar]);

  if (!abierto) return null;

  return (
    <div style={s.overlay} onClick={onCerrar}>
      <div style={{ ...s.modal, maxWidth: ancho }} onClick={e => e.stopPropagation()}>
        <div style={s.header}>
          <h3 style={s.titulo}>{titulo}</h3>
          <button style={s.cerrar} onClick={onCerrar}>✕</button>
        </div>
        <div style={s.body}>{children}</div>
      </div>
    </div>
  );
}

const s = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px', overscrollBehavior: 'contain' },
  modal: { background: '#131929', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '16px', width: '100%', boxShadow: '0 25px 60px rgba(0,0,0,0.5)' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 24px', borderBottom: '1px solid rgba(255,255,255,0.08)' },
  titulo: { color: '#fff', fontSize: '16px', fontWeight: '600' },
  cerrar: { background: 'none', border: 'none', color: 'rgba(255,255,255,0.4)', fontSize: '16px', cursor: 'pointer', padding: '4px 8px', borderRadius: '6px' },
  // 88vh y no 75: el formulario del cliente tiene varias secciones y con 75 se veia
  // por un tunel, obligando a rodar todo el tiempo para comparar dos campos.
  body: { padding: '24px', maxHeight: '88vh', overflowY: 'auto' },
};
